import { render } from "./UserNotesSearch.vue?vue&type=template&id=08590e30"
import script from "./UserNotesSearch.vue?vue&type=script&lang=js"
export * from "./UserNotesSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__